var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"bloco_principal"},[_c('div',{staticClass:"bloco_titulo"},[_vm._v(" News ")]),_c('div',{staticClass:"bloco_texto"},[_vm._v(" Este é um texto de bloco de texto ")]),_c('v-divider')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }